var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeart2 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.9 4c-1.5 0-2.8.5-3.8 1.5-.8.8-1.2 1.7-1.4 2.7h-.2c-.2-1-.7-1.9-1.4-2.7-1-1-2.3-1.5-3.8-1.5s-2.8.5-3.8 1.5S1 7.8 1 9.3s.7 2.7 1.5 3.8c.7.9 2.3 2.6 3.9 3.9 2 1.6 3.9 2.9 5.3 2.9 1.3 0 3.1-1.3 5.1-2.9 1.6-1.3 3.2-3.1 3.9-3.9.9-1.1 1.5-2.3 1.5-3.8s-.5-2.8-1.5-3.8S18.5 4 16.9 4"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart2);
export default ForwardRef;